import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ShieldAlert } from "lucide-react";

/** Hard-to-misclick confirmation: requires ticking an explicit acknowledgement. */
export function ConfirmDialog({ open, onOpenChange, title, description, ackLabel, confirmLabel, onConfirm, destructive, testid }) {
  const [ack, setAck] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      onOpenChange(false);
      setAck(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setAck(false); }}>
      <AlertDialogContent data-testid={testid || "confirm-dialog"} className="border-border">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 font-heading">
            <ShieldAlert className={`h-5 w-5 ${destructive ? "text-rose-400" : "text-primary"}`} />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex items-start gap-3 rounded-lg border border-border bg-muted/40 p-3">
          <Checkbox id="ack" checked={ack} onCheckedChange={setAck} data-testid="confirm-ack-checkbox" className="mt-0.5" />
          <Label htmlFor="ack" className="text-sm leading-snug cursor-pointer">{ackLabel}</Label>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-action-btn"
            disabled={!ack || busy}
            onClick={(e) => { e.preventDefault(); handleConfirm(); }}
            className={destructive ? "bg-rose-600 hover:bg-rose-700" : ""}
          >
            {busy ? "Working…" : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
